import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-[90vh] flex flex-col items-center justify-center py-20 px-6 overflow-hidden bg-[#FAF6F0]" data-id="element-56">
      {/* Decorative background element */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-30" data-id="element-57">
        <div className="absolute -top-[20%] -right-[10%] w-[600px] h-[600px] rounded-full bg-[#D4A89A] blur-[100px]" data-id="element-58" />
        <div className="absolute top-[40%] -left-[10%] w-[500px] h-[500px] rounded-full bg-[#B8845C] blur-[120px] opacity-60" data-id="element-59" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-60">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="inline-block mb-6 text-[#B8845C] font-serif italic text-xl md:text-2xl tracking-wide" data-id="element-61">
          Para mujeres que sienten el eco de la soledad
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-4xl md:text-6xl lg:text-7xl font-bold text-[#3D2B1F] leading-[1.1] mb-8" data-id="element-62">
          Cuando la casa se queda en silencio…{' '}
          <br className="hidden md:block" data-id="element-63" />
          <span className="text-[#B8845C]" data-id="element-64">¿y tú qué haces a las 6:30pm?</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="my-12 relative" data-id="element-65">
          <div className="absolute inset-0 bg-[#B8845C] rounded-2xl rotate-1 opacity-20 blur-xl transform scale-95" data-id="element-66" />
          <img src="https://cdn.magicpatterns.com/uploads/93jPTbPpmyBy79FDtFdxhi/heylloyd-image-1770504325262.png" alt="El Plan 21 Días: Casa Silenciosa en una tablet sobre una mesa cálida" className="relative rounded-lg shadow-2xl w-full max-w-2xl mx-auto border-4 border-white/50" data-id="element-67" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.8
      }} className="max-w-2xl mx-auto text-left md:text-center" data-id="element-68">
          <p className="text-xl md:text-2xl text-[#3D2B1F]/90 leading-relaxed font-serif" data-id="element-69">
            Hay una hora del día que no avisa… pero tú ya la conoces. La tarde
            cae. La luz cambia. Terminas de recoger. Te sientas "un ratito". Y
            de pronto, tu casa se siente demasiado grande.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 1.2
      }} className="mt-12" data-id="element-70">
          <Button size="lg" onClick={() => document.getElementById('offer')?.scrollIntoView({
          behavior: 'smooth'
        })} className="text-xl px-12 py-8 shadow-xl shadow-[#B8845C]/20" data-id="element-71">
            Ver El Plan 21 Días
          </Button>
          <p className="mt-4 text-[#3D2B1F]/60 text-sm italic" data-id="element-72">
            Lectura de 5 minutos que podría cambiar tus tardes
          </p>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#B8845C]/50 animate-bounce" data-id="element-73">
        <ArrowDown size={32} data-id="element-74" />
      </motion.div>
    </section>;
}